export const PAYMENT_DISPLAY_PREFIX = 'altapay-script-frame';

export enum AltaPayStatus {
    IDLE,
    PENDING,
    SUCCESS,
    ERROR,
}

export enum AltaPayErrorCode {
    UNAUTHORIZED = 313007,
    SESSION_NOT_FOUND = 340001,
    AUTHENTICATION_FAILED = 352001,

    /** Custom Error Codes */
    ORDER_MISMATCH = 700001,
}

// AltaPay tokens last 1 hour. We get a new one when 7 minutes or less are left.
export const ALTAPAY_TOKEN_RENEWAL_BUFFER_IN_MINUTES = 7;

export enum AltaPayStorageKey {
    AUTH = '_aa',
}

/**
 * This is a custom header that will be added to PUT /orders/{orderNo}.
 * It will act as a flag for SFCC to bypass customer groups by utilizing Source Codes.
 */
export const HEADER_ALTAPAY_ORDER_KEY = 'Skip-Customer-Group';
export const HEADER_ALTAPAY_ORDER_VALUE = '1';
